import * as ACTION_TYPES from "../actions/action-types";

const initialState = {
  editLayout: false,
  widgetHeader: [],
  kpiCardsData: [],
  focusArea: {
    myTeams: 1,
    recentlyViewed: 1,
    tasksCreated: 1,
    workflowsAccessed: 1,
    comments: 1,
    reminders: 1,
  },
  kpiIndicators: {
    planMyDay: 1,
    overdueTasks: 1,
    emails: 1
  },
  selectedValues: [],
};

/**
 * setting states according to the type of actions
 * @param {*} state
 * @param {*} action
 * @returns {state}
 */

const landingPage = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.SET_EDIT_LAYOUT:
      return {
        ...state,
        editLayout: payload,
      };
    case ACTION_TYPES.SET_WIDGET_HEADER:
      return {
        ...state,
        widgetHeader: payload,
      };
    case ACTION_TYPES.KPI_CARDS_DATA:
      return {
        ...state,
        kpiCardsData: payload,
      };
    case ACTION_TYPES.SET_FOCUS_AREA:
      return {
        ...state,
        focusArea: payload,
      };
    case ACTION_TYPES.SET_KPI_INDICATORS:
      return {
        ...state,
        kpiIndicators: payload,
      };
    case ACTION_TYPES.SET_SELECTED_VALUES:
      return {
        ...state,
        selectedValues: payload,
      };
    default:
      return state;
  }
};

export default landingPage;
